// src/pages/CTechnicianDashboard.js
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import useResponsive from "../hooks/useResponsive";
import useAuthUser from "../hooks/useAuthUser";
import { useCalendarEvents } from "../hooks/useCalendarEvents";
import CalendarView from "../components/calendar/calendarView";
import Sidebar from "../components/layout/usSidebar";
import CalendarLegend from "../components/calendar/calendarLegend";
import logo from "../assets/logo.png";

export default function CTechnicianDashboard() {
  const { firebaseUser, signOut } = useAuthUser();
  const { filteredEvents, formatDateTime, getTitleColor, loading } = useCalendarEvents(firebaseUser);
  const navigate = useNavigate();
  const { isMobile } = useResponsive();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [profileOpen, setProfileOpen] = useState(false);
  const [payrollOpen, setPayrollOpen] = useState(false);
  const [formsOpen, setFormsOpen] = useState(false);
  // const [warehouseOpen, setWarehouseOpen] = useState(false);

  if (loading) return <div>Loading events...</div>;

  // Calendar Views & Toolbar
  const calendarViews = isMobile
    ? { timeGridWeek: { buttonText: "Week" }, dayGridMonth: { buttonText: "Month" } }
    : {
      dayGridDay: { buttonText: "Day" },
      timeGridWeek: { buttonText: "Week" },
      dayGridMonth: { buttonText: "Month" },
      listWeek: { buttonText: "List" },
    };

  const headerToolbar = {
    left: "prev,next today",
    center: "title",
    right: Object.keys(calendarViews).join(","),
  };

  const initialView = isMobile ? "dayGridMonth" : "dayGridMonth";

  return (
    <div className="flex min-h-screen bg-gray-100 min-w-0">
      {/* Sidebar */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        navigate={navigate}
        logo={logo}
        signOut={signOut}
        profileOpen={profileOpen}
        setProfileOpen={setProfileOpen}
        payrollOpen={payrollOpen}
        setPayrollOpen={setPayrollOpen}
        formsOpen={formsOpen}
        setFormsOpen={setFormsOpen}
      />


      <main className="flex-1 font-sans flex flex-col md:ml-64 min-w-0 max-w-full overflow-hidden">
        {/* Mobile top bar */}
        <div className="md:hidden flex items-center gap-3 px-3 py-2 bg-white shadow z-40">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-2 bg-gray-100 rounded shadow"
          >
            <Menu size={24} />
          </button>

          <div className="flex-1 overflow-x-auto">
            <CalendarLegend />
          </div>
        </div>

        <CalendarView
          events={filteredEvents}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          calendarViews={calendarViews}
          headerToolbar={headerToolbar}
          initialView={initialView}
          getTitleColor={getTitleColor}
          formatDateTime={formatDateTime}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      </main>
    </div>
  );
}